import React from "react";
import swal from "sweetalert";
import Swal from "sweetalert2";
import CarTypeSelector from "../components/car_type_selector";
import ImageEvent from "../components/image_event";
import InputConfigure from "../components/input_configure";
import SelectJurisdiction from "../components/select_jurisdiction";
import UserService from "../services/user_service";

class ConfigureUser extends React.Component {
  state = {
    currentUser: null,
  }

  handleTap() {
    const { value } = document.querySelector('#config-email-input') as HTMLInputElement;

    if (!!value) {
      swal("Cargando ...");
      new UserService().getUser(value).then(response => {
        swal.close();

        if (response === null) {
          swal({
            title: "Error",
            text: "No hemos encontrado un usuario para este correo",
          });
          return;
        }

        this.setState({
          currentUser: response,
        })
      });
    } else {
      swal({
        title: "No has ingresado un correo valido",
      })
    }
  }

  async sendEmail() {
    const response = await swal({
      text: "¿Quieres enviar el correo de recuperación de contraseña?",
      buttons: ["Si, Enviar", "No, Cerrar"]
    });

    if (response === null) {
      swal("Cargando ...");
      await new UserService().sendPasswordRecovery(this.state.currentUser.email);
      swal.close();
      swal("Correo Enviado");
    }

  }

  async convertAdmin(isAdmin: boolean): Promise<void> {
    const message = "¿Estas seguro de convertir este usuario a " + (isAdmin ? "Usuario" : "Administrador") + "?";
    const response = await swal({
      title: "Cudiado!!",
      text: message,
      buttons: ["Si, Convertir", "No, Cerrar"]
    });

    if (response === null) {
      swal("", "Cargando ...");
      let data = this.state.currentUser;
      data['isAdmin'] = !isAdmin;
      await new UserService().updateUser(data);
      swal.close();
      this.setState({
        currentUser: data
      })
    }
  }

  renderHeader() {
    const user = this.state.currentUser;
    const isAdmin = user.isAdmin || false;
    return (
      <>
        <div className="buttons">
          <button className="button is-danger is-light" onClick={() => {
            this.setState({
              currentUser: null
            })
          }}>Cerrar</button>
          <button className="button is-info is-light" onClick={() => this.sendEmail()}>Correo de Cambio de Contraseña</button>
          <button
            className="button is-info is-danger"
            onClick={() => this.convertAdmin(isAdmin)}>{isAdmin ? "Convertir en Usuario" : "Convertir en Administrador"}</button>
        </div>

        <ImageEvent imagePath={user.photoUrl}>
          <div className="header-user">
            <img src={user.photoUrl} alt="user-image" />
            <div className="heder-user-data">
              <h1>{user.fullName}</h1>
              <p>{user.email}</p>
              <p>{this.getRole()}</p>
            </div>
          </div>
        </ImageEvent>
      </>
    );
  }

  getRole(): string {
    const role = this.state.currentUser['role'];

    switch (role) {
      case "USER": return "Usuario"; break;
      case "DRIVER":
        if (!!this.state.currentUser.isMultiService) {
          return "Conductor y Delivery";
        }
        return "Conductor";
        break;
      case "DELIVERY": return "Delivery"; break;
      default: return "Usuario"; break;
    }
  }

  renderTitle(text: string): JSX.Element {
    return (
      <h1 className="text-title">{text}</h1>
    );
  }

  renderItem(params: { title: string, text: string, field: string }): JSX.Element {
    return <InputConfigure title={params.title} text={params.text} onUpdate={async (text: string) => {
      let data = this.state.currentUser;
      data[params.field] = text;

      const response = await swal({
        title: "Cuidado",
        text: "¿Quieres actualizar este campo?",
        buttons: ["Si, Modificar", "No, Cerrar"]
      });

      if (response === null) {
        swal("Cargando ...");
        await new UserService().updateUser(data);
        swal.close();
      }
    }} />
  }


  renderFile(params: { path: string, name: string }): JSX.Element {

    return (
      <ImageEvent imagePath={params.path}>
        <div className="field card">
          <div className="container-file-view">
            <label className="label">Abrir Archivo</label>
            <p>{params.name}</p>
          </div>
        </div>
      </ImageEvent>
    );
  }


  renderCheck(params: { title: string, description: string, field: string }): JSX.Element {
    const state = this.state.currentUser[params.field] || false;
    return (
      <div className="field card checkbox">
        <div className="_title">
          <h1>{params.title}</h1>
          <span>{params.description}</span>
        </div>

        <label className="checkbox">
          <input type="checkbox" defaultChecked={state} onChange={async (_) => {
            const response = await swal({
              title: "Cuidado",
              text: "Estás por modificar el valor",
              buttons: ["Si, Continuar", "No, Cerrar"]
            });

            if (response === null) {
              swal("Cargando ...");
              let data = this.state.currentUser;
              data[params.field] = !state;
              await new UserService().updateUser(data);
              swal.close();
              this.setState({
                currentUser: data
              })
            }
          }} />
        </label>
      </div>
    );
  }

  renderVehicleType(){    
    return <CarTypeSelector 
      typeId={this.state.currentUser['carTypeId'] || "hYzf0GOAYGJ4kOdxu2qZ"}
      onChange={async (newId: string)=> {
        const response = await swal({
          title: "Cambiar Tipo de Vehiculo",
          text: "¿Deseas cambiar el tipo de vehiculo?",
          buttons: [
            "Si, Cambiar",
            "No, Cerrar"
          ]
        });        

        if(response == null){
          Swal.showLoading();
          await new UserService().updateUser({
            "carTypeId": newId,
            "id": this.state.currentUser['id'],
          });
          
          Swal.close();
          Swal.fire("Actualizado correctamente");
        }
      }}
    />
  }

  render() {
    if (this.state.currentUser === null) {
      return (<form className="box config-user-box-form">
        <div className="field">
          <label className="label">Correo</label>
          <div className="control">
            <input className="input" type="email" placeholder="e.g. alex@example.com" id="config-email-input" />
          </div>
        </div>
        <button className="button is-primary" onClick={() => this.handleTap()}>Buscar</button>
      </form>);
    }

    return (
      <div className="config-user-container">
        {this.renderHeader()}
        <div className="container-user-information">
          <div className="section">
            {this.renderTitle("Informacion Basica")}
            {this.renderItem({ title: "Nombre de Usuario", text: this.state.currentUser.fullName, field: "fullName" })}
            {this.renderItem({ title: "Correo", text: this.state.currentUser.email, field: "email" })}
            {this.renderItem({ title: "Numero de Telefono", text: this.state.currentUser.phone, field: "phone" })}
            {this.renderItem({ title: "Creacion de la Cuenta", text: this.state.currentUser.createdAt, field: "createdAt" })}


            {
              (this.state.currentUser['role'] !== "USER" && !!this.state.currentUser.carIdentifier) && (
                <>
                  {this.renderTitle("Informacion del Vehiculo")}

                  {this.renderItem({ title: "Placa del Vehiculo", text: this.state.currentUser.carIdentifier, field: "carIdentifier" })}
                  {this.renderItem({ title: "Modelo", text: this.state.currentUser.carModel, field: "carModel" })}
                  {this.renderItem({ title: "Color del Vehiculo", text: this.state.currentUser.color, field: "color" })}
                  {this.renderItem({ title: "Marca del Vehiculo", text: this.state.currentUser.marca, field: "marca" })}
                  {this.renderItem({ title: "Año del Vehiculo", text: this.state.currentUser.year, field: "year" })}

                  <SelectJurisdiction
                    rol={this.state.currentUser.role}
                    currentJurisdiction={this.state.currentUser.jurisdiction}
                    userId={this.state.currentUser.id}
                  />
                </>
              )
            }

          </div>

          {
            this.state.currentUser['role'] !== "USER" && (
              <div className="section">

                {
                  (!!this.state.currentUser.carIdentifier) && (
                    <>
                      {this.renderTitle("Documentacion")}
                      {this.renderFile({ name: "T. de Circulación", path: this.state.currentUser.circulationCard })}
                      {this.renderFile({ name: "Licencia", path: this.state.currentUser.license })}
                    </>
                  )
                }
                {this.renderTitle("Ajustes")}
                {this.renderCheck({ title: "Estado de la Cuenta", description: "Habilita/Deshabilita la cuenta", field: "isActived" })}
                {this.renderCheck({ title: "Online", description: "Define si está Online/Offline", field: "isOnline" })}
                {this.renderVehicleType()}


              </div>
            )
          }
        </div>
      </div>
    );
  }
}

export default ConfigureUser;